import { registerSW } from "virtual:pwa-register";
import "./pwa-detect";
import "./styles/app.css";
import "./game/legacy-app";
import { mountHomeAmbientBalls } from "./game/home-ambient-balls";
import { mountNewsUi } from "./game/news-ui";
import { mountModesScreen } from "./game/modes-screen";
import { mountModeContextMenu } from "./game/mode-context-menu";
import { mountUiSounds } from "./game/ui-sounds";
import { observeGameRangeSliders } from "./game/game-range";
import { mountGameSelects } from "./game/game-select";
import { mountHookAimJoystick } from "./game/hook-aim-joystick";
import { mountFpsOverlay, scheduleFpsOverlayPosition } from "./game/fps-overlay";
import { mountCustomScrollbars } from "./game/custom-scrollbar";
import { ensureHomePlayStreakUi, refreshAllPlayStreakUi, syncPlayStreaksFromServer } from "./game/play-streaks";
import { isAccountSyncReady } from "./game/account-sync";
import { GAME_VERSION_LABEL } from "./version";
import { initWhatsNewModal } from "./game/whats-new-modal";

registerSW({
  immediate: true,
  onRegisteredSW(_swUrl, registration) {
    if (!registration) return;
    const poll = () => registration.update().catch(() => {});
    poll();
    document.addEventListener("visibilitychange", () => {
      if (document.visibilityState === "visible") poll();
    });
  },
});

if ("serviceWorker" in navigator) {
  let reloadedForSw = false;
  navigator.serviceWorker.addEventListener("controllerchange", () => {
    if (reloadedForSw) return;
    reloadedForSw = true;
    window.location.reload();
  });
}

/** Never leave the bootstrap overlay up if auth init stalls or throws later in legacy-app. */
function dismissBootstrapOverlayIfNeeded(): void {
  const overlay = document.getElementById("accountBootstrapOverlay");
  if (!overlay || overlay.classList.contains("hidden")) return;
  overlay.classList.add("hidden");
  document.body.classList.remove("account-bootstrap-active");
}

window.setTimeout(dismissBootstrapOverlayIfNeeded, 15000);

function injectSiteFooter(): void {
    if (document.getElementById("siteFooter")) return;
    const year = new Date().getFullYear();
    const footer = document.createElement("footer");
    footer.id = "siteFooter";
    footer.className = "site-footer";
    footer.setAttribute("role", "contentinfo");
    footer.innerHTML = `© ${year} CursorGame — All rights reserved · <span class="site-footer-credits">Credits: AdriLou111</span>`;
    document.body.appendChild(footer);
}

function injectHomeVersionLabel(): void {
    const el = document.getElementById("homeVersionLabel");
    if (el) el.textContent = GAME_VERSION_LABEL;
}

injectSiteFooter();
injectHomeVersionLabel();
ensureHomePlayStreakUi();
mountHomeAmbientBalls();
mountNewsUi();
mountModesScreen();
mountModeContextMenu();
mountUiSounds();
observeGameRangeSliders();
mountGameSelects();
mountHookAimJoystick();
mountFpsOverlay();
mountCustomScrollbars();
initWhatsNewModal();
window.addEventListener("resize", () => scheduleFpsOverlayPosition(), { passive: true });
document.addEventListener("visibilitychange", () => {
  if (document.visibilityState !== "visible") return;
  refreshAllPlayStreakUi();
  if (isAccountSyncReady()) void syncPlayStreaksFromServer({ pushIfLocalHigher: true });
});
